import {forwardRef} from 'react'
import {twJoin} from 'tailwind-merge'
import {useParams} from 'react-router-dom'

import {getTrackingProps} from '@sdox/utils/dom'
import {SdoxWatermark, TextLink} from '@sdox/ui'
import {twMerge} from '@sdox/utils'
import {useCurrentContactPerson, useCurrentOffice, useCurrentOrgId} from '@sdox/api'

import {FooterDisclaimers} from './FooterDisclaimers'
import {PrivacyDialogTab, useTabbedPrivacyDialogStore} from '../Dialogs/LegalDialogs/TabbedPrivacyDialog'

import type {FooterDisclaimersProps} from './FooterDisclaimers'
import type {MouseEventHandler} from 'react'

export interface FooterProps {
  id?: string
  className?: string
  disclaimers?: FooterDisclaimersProps['disclaimers']
}

export const Footer = forwardRef<HTMLFormElement, FooterProps>((props, ref) => {
  const {className, id, disclaimers} = props

  const {seFolderSlug, clpSlug} = useParams()
  const office = useCurrentOffice()
  const contactPerson = useCurrentContactPerson()
  const orgId = useCurrentOrgId()

  const openPrivacyDialogTab = useTabbedPrivacyDialogStore(state => state.selectTab)

  const openDialog: MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault()
    openPrivacyDialogTab(PrivacyDialogTab.PrivacyPolicy)
  }

  return (
    <footer
      id={id}
      ref={ref}
      className={twMerge('@container', className)}
    >
      <FooterDisclaimers disclaimers={disclaimers} />
      <div
        className={twJoin(
          'flex items-center justify-between flex-col text-glyph-default-secondary',
          'gap-spacing-32 px-spacing-20 pb-spacing-128',
          '@[601px]:gap-spacing-32 @[601px]:flex-row @[601px]:items-center @[601px]:px-0',
        )}
      >
        <div className={'flex gap-spacing-32'}>
          <TextLink
            href={office?.imprintUrl ?? '#'}
            className={'text-p2 !text-glyph-default-secondary'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            {...getTrackingProps({prefix: 'Footer', piece: 'Impressum'})}
          >
            Impressum
          </TextLink>
          <TextLink
            className={'text-p2 !text-glyph-default-secondary'}
            onClick={openDialog}
            {...getTrackingProps({prefix: 'Footer', piece: 'Datenschutz'})}
          >
            Datenschutz
          </TextLink>
        </div>
        <div className={'flex items-center gap-spacing-6 text-p2 opacity-70'}>
          <SdoxWatermark
            contactPersonId={contactPerson?.id ?? undefined}
            officeId={office?.id ?? undefined}
            slug={seFolderSlug ?? clpSlug ?? undefined}
            orgId={orgId ?? undefined}
            className={'h-spacing-14'}
          />
        </div>
      </div>
    </footer>
  )
})
